<template>
  <div>
    <v-tooltip bottom class="action-buttons">
      <v-btn small icon flat color="#293968" slot="activator">
        <v-icon color="primary lighten-2" @click="mostrarAdjuntos" :disabled="sinAdjuntos">picture_as_pdf</v-icon>
      </v-btn>
      <span>

      <template v-if="sinAdjuntos">
        No tiene adjuntos
      </template>
      <template v-else>
        Adjuntos
      </template>
      </span>
    </v-tooltip>
    <adjuntos-pagos-popup ref="adjuntosPopup" :adjuntos="adjuntos"></adjuntos-pagos-popup>
  </div>
</template>

<script>

import AdjuntosPagosPopup from './AdjuntosPagosPopup'

export default {
  props: {
    adjuntos: Array
  },

  methods: {
    mostrarAdjuntos () {
      if (this.unAdjunto) {
        window.open(this.adjuntos[0].comprobantes[0].url, '_blank')
      } else {
        this.$refs.adjuntosPopup.showDialog()
      }
    }
  },

  computed: {
    sinAdjuntos () {
      return this.adjuntos.length === 0
    },
    unAdjunto () {
      return this.adjuntos.length === 1
    }
  },

  components: {
    AdjuntosPagosPopup
  }
}
</script>

<style>

</style>
